import React from 'react';
import { ShieldCheck, ChevronLeft } from 'lucide-react';

const Privacy = () => {
  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '40px auto', 
      padding: '20px', 
      fontFamily: 'sans-serif', 
      lineHeight: '1.6',
      color: '#1e293b' 
    }}>
      <header style={{ borderBottom: '2px solid #fbbf24', paddingBottom: '20px', marginBottom: '30px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#064e3b' }}>
          <ShieldCheck size={32} />
          <h1 style={{ margin: 0 }}>SafeGuard NG Privacy Policy</h1>
        </div>
        <p style={{ margin: '10px 0 0', fontWeight: 'bold' }}>Official Disclosure for Nathconsult LLC</p>
      </header>

      <section>
        <p><strong>Last Updated:</strong> March 3, 2026</p>
        <p>This Privacy Policy describes how <strong>Nathconsult LLC</strong> ("we", "us", or "our") collects and handles information through the SafeGuard NG mobile application.</p>
        
        <h3>1. Information Collection</h3>
        <p>We collect your Name, Phone Number, and Email to create your account. During an incident report, the app collects your <strong>Precise Location</strong> to assist emergency responders.</p>
        
        <h3>2. Optional Identification</h3>
        <p>Users may optionally provide an ID Number (e.g., Passport or Driver's License number). This is a <strong>text-only</strong> field used for identity verification. We do not request or store images of physical ID documents.</p>

        <h3>3. Data Usage</h3>
        <p>Data is used exclusively for emergency response coordination and is shared only with authorized government agencies during an active report.</p>

        <h3>4. Data Deletion</h3>
        <p>Users can request data deletion at any time by contacting <strong>support@nathconsult.com</strong>.</p>
      </section>

      <footer style={{ marginTop: '50px', paddingTop: '20px', borderTop: '1px solid #e2e8f0' }}>
        <button 
          onClick={() => window.location.href = '/'}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '5px', 
            background: '#064e3b', 
            color: 'white', 
            border: 'none', 
            padding: '10px 20px', 
            borderRadius: '8px', 
            cursor: 'pointer' 
          }}
        >
          <ChevronLeft size={18} /> Back to Portal
        </button>
      </footer>
    </div>
  );
};

export default Privacy;